module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_23 (30).c21318d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_23 (30).mp4
// module id = 805
// module chunks = 1